import React from "react";
import { FaMapMarkerAlt, FaCalendarAlt } from "react-icons/fa";
import UseGetDashBoardData from "../../../../Components/Hooks/useDashboardData";
import { useNavigate } from "react-router-dom";
import NuDate from "../../../../Components/Utils/NuDate";
import { GetAccess, GetUseRole } from "../../../../Components/Utils/roles";

function Upcoming() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/upcoming-inspections`);
  const navigate = useNavigate();

  const handleNavigate = (id) => {
    navigate(`/inspection/schedule/view/${id}`, {
      state: { fromDashboard: true }
    });
  };

  const handleNavigateEdit = (inspection) => {
    navigate(`/inspection/schedule/edit/${inspection.id}`, {
      state: {
        from: "/dashboard",
      },
    });
  };
  
;

  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg">
      <h2 className="text-sm font-bold">Upcoming Inspections</h2>
      {/* {GetUseRole("client") ?( */}
                   <p className="text-gray-500 mb-2 text-xs font-light">Scheduled for the next 30 days</p>

              {/* // ):(
              //   <p className="text-gray-500 mb-2 text-xs font-light">Scheduled for the next 7 days</p>

              // )}  */}
      <div className="overflow-y-scroll h-[80%]">
        {data.map((inspection) => (
          <div
            key={inspection.id}
            className="border p-2 rounded-lg mb-3 flex justify-between items-center bg-white hover:bg-slate-50 transition"
          >
            <div>
              {GetUseRole('client') ?(
              <h3 className="text-xs font-semibold mb-1 mt-2">{inspection.refNumber}</h3>

              ):(
              <h3 className="text-xs font-semibold mb-1 mt-2">{inspection.clientName}</h3>

              )} 
              <p className="text-gray-500 flex items-center gap-1 text-xs mb-1">
                <FaMapMarkerAlt className="text-gray-400" />
                {inspection.location || "None"}
              </p>
              <p className="text-gray-500 flex items-center gap-1 text-xs">
                <FaCalendarAlt className="text-gray-400" />
                {inspection.date? (
                       <NuDate
                         value={inspection?.date}
                         format="DD-MMM-YYYY"
                       />
                     ) : (
                       "N/A"
                     )}
              </p>
            </div>
            <div className="text-right space-y-2">
              <div>
                <span
                  className={`px-2 py-0.5 text-[10px] font-semibold rounded-full ${inspection.typeColor}`}
                >
                  {inspection.inspectionType}
                </span>
              </div>
              <div className="flex gap-2 justify-end">
                 {!GetUseRole("client") && GetAccess('commissioning_schedules_edit') && (
                <button
                  className="px-2 py-1 text-[10px] border border-gray-300 rounded-md text-gray-600 hover:bg-gray-200 transition"
                  onClick={() => handleNavigateEdit(inspection)}
                >
                  Reschedule
                </button>
                 )}
                 {GetAccess('commissioning_schedules_view') &&
                <button
                  className="px-2 py-1 text-[10px] bg-gray-800 text-white rounded-md hover:bg-gray-700 transition"
                  onClick={() => handleNavigate(inspection.id)}
                >
                  Details
                </button>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Upcoming;
